"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _jsxRuntime = require("react/jsx-runtime");

var StyledAvatar = (0, _material.styled)(_material.Avatar)(function (_ref) {
  var theme = _ref.theme;
  return {
    fontSize: "0.9rem",
    height: theme.spacing(4),
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(2),
    width: theme.spacing(4)
  };
});
var StyledBox = (0, _material.styled)(_material.Box)(function () {
  return {
    maxWidth: "150px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
});
var StyledTypography = (0, _material.styled)(_material.Typography)(function () {
  return {
    lineHeight: "40%",
    marginTop: "0.5rem",
    overflow: "visible"
  };
});

var NavUser = function NavUser(_ref2) {
  var name = _ref2.name,
      organization = _ref2.organization,
      _ref2$src = _ref2.src,
      src = _ref2$src === void 0 ? " " : _ref2$src;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAvatar, {
      alt: name,
      src: src
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBox, {
      mr: 4,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTypography, {
        color: "textPrimary",
        display: "block",
        noWrap: true,
        variant: "caption",
        children: name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTypography, {
        color: "textSecondary",
        noWrap: true,
        variant: "caption",
        children: organization
      })]
    })]
  });
};

var _default = NavUser;
exports.default = _default;